export const SHOW = 'FavoritesModal/show';
